module.exports = __webpack_public_path__ + "static/media/sub_menu_makeup_pink.3eb8d101.png";